import { formatCurrency, isUserVisibleCategory } from "./dashboardUtils";

function CategoryRow({ item }) {
  return (
    <tr className="border-t">
      <td className="px-4 py-3">
        <div className="font-medium text-zinc-900">{item.label}</div>
      </td>
      <td className="px-4 py-3 text-right font-semibold text-zinc-900">
        {formatCurrency(item.totalAmount)}
      </td>
      <td className="px-4 py-3 text-right text-zinc-500">
        {item.transactionCount || 0}
      </td>
      <td className="px-4 py-3 text-right text-zinc-500">
        {item.lastPaidMonth || "-"}
      </td>
    </tr>
  );
}

function CategoryGroup({ title, description, items }) {
  if (!items.length) return null;

  return (
    <div className="rounded-2xl bg-white shadow">
      <div className="border-b px-4 py-3">
        <h3 className="text-lg font-semibold text-zinc-950">{title}</h3>
        <p className="text-sm text-zinc-500">{description}</p>
      </div>
      <div className="overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead className="bg-zinc-50 text-left text-zinc-500">
            <tr>
              <th className="px-4 py-3 font-medium">Category</th>
              <th className="px-4 py-3 text-right font-medium">Total</th>
              <th className="px-4 py-3 text-right font-medium">Payments</th>
              <th className="px-4 py-3 text-right font-medium">Last Paid</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <CategoryRow key={item.category} item={item} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default function CategoryBreakdown({ items = [] }) {
  const visibleItems = items.filter((item) => isUserVisibleCategory(item.category));
  const mandatory = visibleItems.filter((item) => item.mandatory);
  const fees = visibleItems.filter((item) => item.category === "TRX_FEE");
  const optional = items.filter(
    (item) =>
      isUserVisibleCategory(item.category) &&
      !item.mandatory &&
      item.category !== "TRX_FEE"
  );

  return (
    <section className="grid grid-cols-1 gap-4 xl:grid-cols-3">
      <CategoryGroup
        title="Membership & Ijtima Chanda"
        items={mandatory}
      />
      <CategoryGroup
        title="Other Contributions"
        items={optional}
      />
      <CategoryGroup
        title="Fees"
        items={fees}
      />
    </section>
  );
}
